import {ReactComponent as arrowUpIcon} from "../../graphic/arrow_up_icon.svg"
import {ReactComponent as arrowDownIcon} from "../../graphic/arrow_down_icon.svg"
import {ReactComponent as bracketIcon} from "../../graphic/brackets_icon.svg"
import {ReactComponent as dotsIcon} from "../../graphic/dots_icon.svg"
import {ReactComponent as doubleArrowIcon} from "../../graphic/double_arrow_icon.svg"
import {ReactComponent as gridIcon} from "../../graphic/grid_icon.svg"
import {ReactComponent as homeIcon} from "../../graphic/house_icon.svg"
import {ReactComponent as logoIcon} from "../../graphic/logo_icon.svg"
import {ReactComponent as logoutIcon} from "../../graphic/logout_icon.svg"
import {ReactComponent as terminalIcon} from "../../graphic/terminal_icon.svg"
import {ReactComponent as xIcon} from "../../graphic/x_icon.svg"
import {ReactComponent as xmlIcon} from "../../graphic/xml_icon.svg"

import {ReactComponent as alertIcon } from "../../graphic/resultIcons/alert_icon.svg"
import {ReactComponent as clockIcon } from "../../graphic/resultIcons/clock_icon.svg"
import {ReactComponent as errorIcon } from "../../graphic/resultIcons/error_icon.svg"
import {ReactComponent as notRunIcon } from "../../graphic/resultIcons/not_run_icon.svg"
import {ReactComponent as successIcon } from "../../graphic/resultIcons/success_icon.svg"
export const ArrowUpIcon = arrowUpIcon;
export const ArrowDownIcon = arrowDownIcon;
export const BracketIcon = bracketIcon;
export const DotsIcon  = dotsIcon;
export const DoubleArrowIcon = doubleArrowIcon;
export const GridIcon  = gridIcon ;
export const HomeIcon  = homeIcon
export const LogoIcon =  logoIcon;
export const LogoutIcon =  logoutIcon;
export const TerminalIcon =  terminalIcon;
export const XIcon = xIcon;
export const XmlIcon = xmlIcon;

//** Result icons: **//

export const WarningIcon  = alertIcon
export const LastRunIcon  = clockIcon
export const ErrorIcon = errorIcon
export const NotRunIcon  = notRunIcon
export const SuccessIcon = successIcon


